import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { InlineFilters, useInlineFiltersContext } from 'features/command-center';
import { ActivityTable } from 'features/command-center/components/activity/ActivityTable';
import { NOT_REGISTERED_CALL_ENTITY } from 'features/command-center/components/activity/ActivityTable/ActivityTable.constants';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import { useRecruiterInfoContext } from 'features/command-center/contexts';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { useUserContext } from 'providers/UserProvider';
import { userHasRole } from 'services/Authorization';
import { EntityType } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { Roles } from 'UI/constants/roles';
import { getDefaultDashboardPeriod } from 'UI/utils';

const GLOBAL_FILTERS = [
  'dateRange',
  'activityType',
  'emailVerdicts',
  'industries',
  'specialties',
  'subspecialties',
  'countries',
  'state',
  'cities'
];

const extraFilters = [
  {
    type: 'dateRange',
    name: 'dateRange',
    placeholder: 'Date Range',
    defaultRange: getDefaultDashboardPeriod()
  }
];

export const Activity = ({ recruiterId }) => {
  const { filters, handleFiltersChange } = useInlineFiltersContext();
  const [currentUser] = useUserContext();
  const { recruiterData } = useRecruiterInfoContext();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const isOperationsUser = userHasRole(Roles.Operations, currentUser);

  const isOwner = currentUser?.id === recruiterData?.userId;

  const isInlineEditionEnabled =
    (isOwner || isOperationsUser) &&
    checkIfFeatureFlagEnabled(FeatureFlags.ActivityOutcomeInlineEdition);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <InlineFilters
          persistenceKey={INLINE_FILTERS_KEYS.activity.recruiterGlobal}
          filters={GLOBAL_FILTERS}
          extraFilters={extraFilters}
          onFiltersChange={handleFiltersChange}
        />
        <Divider />
      </Grid>

      <Grid item container xs={12}>
        <ActivityTable
          entity={EntityType.Candidate}
          recruiterId={recruiterId}
          globalFilters={filters}
          canExpandRow={isInlineEditionEnabled}
        />
      </Grid>

      <Grid item container xs={12}>
        <ActivityTable
          entity={EntityType.HiringAuthority}
          recruiterId={recruiterId}
          globalFilters={filters}
          canExpandRow={isInlineEditionEnabled}
        />
      </Grid>

      <Grid item container xs={12}>
        <ActivityTable
          entity={EntityType.Contact}
          recruiterId={recruiterId}
          globalFilters={filters}
          canExpandRow={isInlineEditionEnabled}
        />
      </Grid>

      <Grid item container xs={12}>
        <ActivityTable
          entity={EntityType.Company}
          recruiterId={recruiterId}
          globalFilters={filters}
          canExpandRow={isInlineEditionEnabled}
        />
      </Grid>

      <Grid item container xs={12}>
        <ActivityTable
          entity={NOT_REGISTERED_CALL_ENTITY}
          recruiterId={recruiterId}
          globalFilters={filters}
          canExpandRow={isInlineEditionEnabled}
        />
      </Grid>
    </Grid>
  );
};
